import { BreadcrumbItem, BreadcrumbType } from "../../generated-api/device";
import { DeviceTabTypeEnum } from "../../types/DeviceTabTypeEnum";
import { routes } from "../../utils/routeHelper";

// These hierarchy levels have no page of their own
const NON_NAVIGABLE_TYPES: BreadcrumbType[] = ["SubAccount", "Section"];

export const isNavigableBreadcrumb = (item: BreadcrumbItem) =>
  !NON_NAVIGABLE_TYPES.includes(item.type);

export const getBreadcrumbLink = (
  item: BreadcrumbItem,
  params: {
    accountId: string;
    installationId: string;
    deviceTab?: DeviceTabTypeEnum;
  },
): string | undefined => {
  switch (item.type) {
    case "Account":
      return routes.account.set(item.id);
    case "Installation":
      return routes.installation.set(params.accountId, item.id);
    case "Device":
    case "SubDevice":
      return routes.device.set(
        params.accountId,
        params.installationId,
        item.id,
        params.deviceTab,
      );
    default:
      return undefined;
  }
};

export const getPreviousNavigableBreadcrumb = (list: BreadcrumbItem[]) =>
  list.slice(0, -1).reverse().find(isNavigableBreadcrumb);
